"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.account = void 0;
exports.accounts = accounts;

var _rxjs = require("rxjs");

var _util = require("@polkadot/api-derive/util");

var _util2 = require("@polkadot/util");

// Copyright 2017-2022 @darwinia/api-derive authors & contributors
// SPDX-License-Identifier: Apache-2.0
const QUERY_OPTS = {
  withDestination: true,
  withLedger: true,
  withNominations: true,
  // eslint-disable-next-line comma-dangle
  withPrefs: true
}; // eslint-disable-next-line space-before-function-paren

function redeemableSum(api, stakingLedger, best) {
  var _reduce, _reduce2;

  const ring = api.registry.createType('Balance', (_reduce = ((stakingLedger === null || stakingLedger === void 0 ? void 0 : stakingLedger.ringStakingLock.unbondings) || []).reduce((total, _ref) => {
    let {
      amount,
      until
    } = _ref;
    return best.gte(until) ? total.add(amount) : total;
  }, new _util2.BN(0))) !== null && _reduce !== void 0 ? _reduce : new _util2.BN(0));
  const kton = api.registry.createType('Balance', (_reduce2 = ((stakingLedger === null || stakingLedger === void 0 ? void 0 : stakingLedger.ktonStakingLock.unbondings) || []).reduce((total, _ref2) => {
    let {
      amount,
      until
    } = _ref2;
    return best.gte(until) ? total.add(amount) : total;
  }, new _util2.BN(0))) !== null && _reduce2 !== void 0 ? _reduce2 : new _util2.BN(0));
  return [ring, kton];
} // eslint-disable-next-line space-before-function-paren


function calculateUnlocking(api, stakingLedger, best, currencyType) {
  if ((0, _util2.isUndefined)(stakingLedger) || !stakingLedger.get(`${currencyType}StakingLock`)) {
    return [undefined, api.registry.createType('Balance', 0)];
  }

  const stakingLock = stakingLedger.get(`${currencyType}StakingLock`);
  const unlockingChunks = stakingLock === null || stakingLock === void 0 ? void 0 : stakingLock.unbondings.filter(_ref3 => {
    let {
      until
    } = _ref3;
    return until.gt(best);
  });

  if (!unlockingChunks || !unlockingChunks.length) {
    return [undefined, api.registry.createType('Balance', 0)];
  }

  const total = Object.entries(unlockingChunks).reduce((all, _ref4) => {
    let [, unbond] = _ref4;
    return all.add(unbond.amount);
  }, new _util2.BN(0));
  return [undefined, api.registry.createType('Balance', total)];
}

function parseResult(api, best, now, query) {
  var _stakingLedger$deposi;

  const stakingLedger = query.stakingLedger;
  const calcUnlocking = calculateUnlocking(api, stakingLedger, best, 'ring');
  const calcUnlockingKton = calculateUnlocking(api, stakingLedger, best, 'kton');
  const depositItems = stakingLedger === null || stakingLedger === void 0 ? void 0 : (_stakingLedger$deposi = stakingLedger.depositItems) === null || _stakingLedger$deposi === void 0 ? void 0 : _stakingLedger$deposi.filter(_ref5 => {
    let {
      expireTime
    } = _ref5;
    return expireTime.toBn().gt(now);
  });
  const total = depositItems === null || depositItems === void 0 ? void 0 : depositItems.reduce((accumulator, item) => accumulator.add(item.value.toBn()), new _util2.BN(0));
  const activeDepositAmount = api.registry.createType('Balance', total);
  return { ...query,
    activeDepositAmount,
    activeDepositItems: depositItems,
    redeemable: redeemableSum(api, stakingLedger, best),
    unlocking: calcUnlocking[0],
    unlockingKton: calcUnlockingKton[0],
    unlockingKtonTotalValue: calcUnlockingKton[1],
    unlockingTotalValue: calcUnlocking[1]
  };
}
/**
 * @description From a list of stashes, fill in all the relevant staking details
 */


function accounts(instanceId, api) {
  return (0, _util.memo)(instanceId, accountIds => {
    const keysObs = api.derive.staking.keysMulti(accountIds);
    const queryObs = api.derive.staking.queryMulti(accountIds, QUERY_OPTS); // rewrite in query.ts

    const bestObs = api.derive.chain.bestNumber();
    const timestampObs = api.query.timestamp.now();
    return (0, _rxjs.combineLatest)([keysObs, queryObs, bestObs, timestampObs]).pipe((0, _rxjs.map)(_ref6 => {
      let [keys, queries, best, timestamp] = _ref6;
      return queries.map((q, index) => ({ ...parseResult(api, best, timestamp, q),
        ...keys[index]
      }));
    }));
  });
}

const account = (0, _util.firstMemo)((api, accountId) => api.derive.staking.accounts([accountId]));
exports.account = account;